import {useDispatch} from 'react-redux'
import Dropdown from 'react-bootstrap/Dropdown'
import {initUser} from './usersSlice'
import users from '../../util/devUsers'
import {devUserOptions} from '../../util/devUsers'
import { useHistory } from "react-router-dom"

const DevUserOptions = props =>{
	const history = useHistory()
	const dispatch = useDispatch()
	return (
		<Dropdown>
			<Dropdown.Toggle variant="success" id="dropdown-basic">
				Dev Users
			</Dropdown.Toggle>

			<Dropdown.Menu>
				{Object.keys(users).map((key, index)=>(
					<Dropdown.Item 
						key={index}
						onClick={()=>{
							devUserOptions.selectedUser = key
							history.push(users[key].route)
							dispatch(initUser())
						}}>
						{key}
					</Dropdown.Item>
				))}
			</Dropdown.Menu>
		</Dropdown>
	)
}

export default DevUserOptions